/**
 * Regras do login de acesso — espelho de server/src/lib/login.ts. O servidor
 * é quem decide; aqui é só para avisar antes de enviar e sugerir um login.
 */
export const LOGIN_MIN_LENGTH = 3;
export const LOGIN_MAX_LENGTH = 32;
const LOGIN_PATTERN = /^[a-z0-9](?:[a-z0-9._-]*[a-z0-9])?$/;

/** Marcas combinantes: no NFD, o acento de "ã" ou "ç" vira uma delas, separada da letra. */
const COMBINING_MARKS = /\p{M}/gu;

export const isValidLogin = (value: string): boolean =>
  value.length >= LOGIN_MIN_LENGTH && value.length <= LOGIN_MAX_LENGTH && LOGIN_PATTERN.test(value);

/** "Camila Duarte" → "camila.duarte": sem acento, espaços viram ponto. */
export function suggestLogin(name: string): string {
  return name
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '.')
    .replace(/[^a-z0-9._-]/g, '')
    .replace(/^[._-]+/, '')
    .slice(0, LOGIN_MAX_LENGTH)
    .replace(/[._-]+$/, '');
}
